import { get, put,Delete,post } from '../axios'

// 网关数据-列表
export const gatewayList = params => get(`/web/collect/gateway/list`,params);

// 网关数据-导出
export const gatewayExport = params => get(`/web/collect/gateway/export`,params);



